import { csvEscape, safeCsvSlug, triggerCsvDownload } from './perfHubCsvUtils';

function summaryRows(summary) {
  if (!summary?.configured) return [];
  const pairs = [
    ['spend_source', summary.spend_source],
    ['spend_inr', summary.spend_inr],
    ['campaign_budget_inr', summary.campaign_budget_inr],
    ['creator_fees_total_inr', summary.creator_fees_total_inr],
    ['cost_per_1k_reach_inr', summary.cost_per_1k_reach_inr],
    ['cpe_engagement_inr', summary.cpe_engagement_inr],
    ['cpm_impressions_inr', summary.cpm_impressions_inr],
    ['cost_per_save_inr', summary.cost_per_save_inr],
    ['posts_with_metrics', summary.posts_with_metrics],
    ['creators_total', summary.creators_total],
    ['allocation_note', summary.allocation_note],
  ];
  const lines = [['metric', 'value'].map(csvEscape).join(',')];
  for (const [k, v] of pairs) {
    if (v != null && v !== '') {
      lines.push([k, v].map(csvEscape).join(','));
    }
  }
  return lines;
}

export function buildCampaignEconomicsCsv(economics) {
  const summary = economics?.summary;
  const perCreator = economics?.per_creator || [];
  const lines = [];

  lines.push('Campaign ROI summary');
  lines.push(...summaryRows(summary));
  lines.push('');
  lines.push('Per creator ROI');

  const headers = [
    'instagram_handle',
    'row_id',
    'fee_inr',
    'spend_inr',
    'allocation',
    'cost_per_1k_reach_inr',
    'cpe_engagement_inr',
  ];
  lines.push(headers.map(csvEscape).join(','));

  for (const row of perCreator) {
    lines.push(
      [
        row.instagram_handle,
        row.row_id,
        row.fee_inr,
        row.spend_inr,
        row.allocation,
        row.cost_per_1k_reach_inr,
        row.cpe_engagement_inr,
      ]
        .map(csvEscape)
        .join(','),
    );
  }

  return lines.join('\n');
}

export function downloadCampaignEconomicsCsv(economics, { campaignName }) {
  const perCreator = economics?.per_creator || [];
  if (!economics?.summary?.configured || !perCreator.length) return;

  const safeCampaign = safeCsvSlug(campaignName);
  const csv = buildCampaignEconomicsCsv(economics);
  triggerCsvDownload(`campaign-roi-${safeCampaign}-all-creators.csv`, csv);
}
